import styled from 'styled-components';

export const Content = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  width: 0;
  height: 0;
`;
